export const customerFormEventsName = {
  ADD_CUSTOMER_DETAILS_START: 'add customer details start',
  ADD_CUSTOMER_DETAILS_FINISH: 'add customer details finish',
  EDIT_CONTACT_INFO_START: 'edit contact info start',
  EDIT_CONTACT_INFO_FINISH: 'edit contact info finish',
  EDIT_LEAD_INFO_START: 'edit lead info start',
  EDIT_LEAD_INFO_FINISH: 'edit lead info finish',
  EDIT_ADDRESS_START: 'edit address start',
  EDIT_ADDRESS_FINISH: 'edit address finish',
};
